module.exports = __webpack_public_path__ + "img/nu.99a3773f.svg";